/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFirstParagraph = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 5h-8V3h8zm-8 2h8v2h-8zm0 4h8v2h-8zM2 15h20v2H2zm20 6H2v-2h20zM2 13 5.915 3h2.142L12 13H9.532l-.68-2.05H5.05L4.369 13zm3.645-3.865h2.596L6.936 5.2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFirstParagraph as FirstParagraph };
